import { ChevronDownIcon } from '@chakra-ui/icons';
import {
  Button,
  Flex,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Spacer,
  Text,
} from '@chakra-ui/react';
import * as _ from 'lodash';
import React from 'react';

import { DownloadWithLoanProductGQLType } from 'types/dashboard-core-gqlTypes.generated';

import { colors } from 'packages/common-frontend/colors';
import { FiDownload } from 'react-icons/fi';

type VerificationDownloadExtendedResponseTapesButtonProps = {
  extendedResponseTapeDownloads: DownloadWithLoanProductGQLType[];
};
export const VerificationDownloadExtendedResponseTapesButton = ({
  extendedResponseTapeDownloads,
}: VerificationDownloadExtendedResponseTapesButtonProps) => {
  return (
    <Menu>
      <MenuButton
        as={Button}
        rightIcon={<ChevronDownIcon />}
        colorScheme="aurora"
        variant="outline"
        borderWidth="2px"
        backgroundColor="white"
      >
        Download Extended Response Tape
      </MenuButton>
      <MenuList zIndex="sticky">
        {_.map(
          extendedResponseTapeDownloads,
          (extendedResponseTapeDownload, idx) => {
            return (
              <MenuItem
                key={`extended-response-tape-${extendedResponseTapeDownload.download.filename}`}
              >
                <Link
                  href={extendedResponseTapeDownload.download.url}
                  color={colors.info}
                  display="flex"
                  alignItems="center"
                  width="100%"
                >
                  <Flex alignItems="center" width="100%">
                    <Text mr="8px">
                      {extendedResponseTapeDownload.loanProduct?.name ||
                        `Loan Product ${idx}`}
                    </Text>
                    <Spacer />
                    <FiDownload />
                  </Flex>
                </Link>
              </MenuItem>
            );
          },
        )}
      </MenuList>
    </Menu>
  );
};
